export async function calculatorCall (query: any, returnObject?: string, variables: object = {}, cache: boolean = true) {
    const { resolveClient } = useApolloClient()
    const client = resolveClient('calculator')
    const { data } = await client.query({
        query,
        variables,
        fetchPolicy: cache ? 'cache-first' : 'no-cache'
    })
    if (data && returnObject) {
        return data[returnObject]
    }
    return data?.value
}
